<div class="flex flex-row header pl-72 pt-16 justify-between">
    <div class="flex flex-row">
      <div>
        <img [routerLink]="['/', tenant]" alt="temenos-logo" class="logo cursor-pointer logo-position mr-8" src="assets/images/temenos-white-logo.svg">
        <div class="pr-16 cloud-text fw-600 fs-14">{{ 'TOOLBAR.CLOUD_DASHBOARD' | transloco }}</div>
      </div>
    </div>
    <mat-toolbar class="pr-32">
        <mat-toolbar-row class="flex flex-row mat-toolbar-row">
            <app-user-menu class="usermenu"></app-user-menu>
        </mat-toolbar-row>
    </mat-toolbar>
</div>
